/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React, { memo } from 'react';
import { Flex, Text } from '@chakra-ui/core';
import { FaCheck } from 'react-icons/fa';
import { ShiftSlotViewModel } from '../../utils/RequisitionDetailsViewModel';
import { MismatchBadge } from '../components/MismatchBadge';
import { EmptyPlaceholder } from '../components/TableComponents';
import colors from '../../../../../../styles/colors';

interface SlotCellProps {
  slot?: ShiftSlotViewModel;
}

/**
 * Renders a single time-slot cell in the comparison table.
 * Shows the formatted time label, a check icon when required,
 * and a mismatch badge when the candidate doesn't cover the slot.
 */
export const SlotCell = memo(({ slot }: SlotCellProps) => {
  if (!slot || !slot.exists || !slot.timeLabel) return <EmptyPlaceholder />;
  return (
    <Flex align="center" justify="space-between" width="100%">
      <Flex align="center" gridGap="4px">
        <Text fontSize="13px">{slot.timeLabel}</Text>
        {slot.isRequired && <FaCheck size={10} color={colors.gray[450]} />}
      </Flex>
      {slot.isMismatch && <MismatchBadge display="inline" />}
    </Flex>
  );
});

SlotCell.displayName = 'SlotCell';
